// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./semantic-theme/semantic.less
// module id = 640
// module chunks = 0